<h4 mat-dialog-title class="text-center">
  {{modalData.title + ' ' + modalData.role}}
</h4>

<mat-dialog-content class="mat-typography" [style]="modalData.customStyle">

  <!-- {{modalData|json}} -->
  <form [formGroup]="accountForm">
    <div class="form-group row">
      <label for="username" class="col-4 col-form-label text-md-right">ชื่อผู้ใช้<lifedi-require></lifedi-require>
      </label>
      <div class="col-6">
        <input type="text" class="form-control" id="username" formControlName="username" style="width: 100%;">
      </div>
    </div>
    <div class="form-group row">
      <label for="email" class="col-4 col-form-label text-md-right">อีเมล<lifedi-require></lifedi-require></label>
      <div class="col-6">
        <input type="email" class="form-control" id="email" formControlName="email" style="width: 100%;">
      </div>
    </div>
    <div class="form-group row" *ngIf="modalData.role !== 'admin'">
      <label for="experties" class="col-4 col-form-label text-md-right">ความถนัด</label>
      <div class="col-6">
        <nz-select nzMode="multiple" nzPlaceHolder="โปรดเลือกความเชี่ยวชาญ" #exp class="text-left"
          [change]="getSelectedItem(exp, accountForm)" [compareWith]="compareFn" style="width: 100%;">
          <nz-option *ngFor="let exp of experties" [nzLabel]="exp.EXPERTIE_NAME" [nzValue]="exp">
          </nz-option>
        </nz-select>
      </div>
    </div>
  </form>
  <p class="text-center text-danger" *ngIf="textError">{{textError}}</p>
  <!-- {{accountForm.value|json}} -->
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button *ngIf="accountForm.valid" (click)="actionFunction()" style="background: #3E8C1A; color: #fff;">
    {{ modalData.actionBtnText }}
  </button>
  <button mat-button *ngIf="!accountForm.valid" (click)="actionFunction()" [disabled]="!accountForm.valid">
    {{ modalData.actionBtnText }}
  </button>
  <button mat-button [mat-dialog-close]="true" (click)="closeModal()">
    {{ modalData.cancleBtnText }}
  </button>
</mat-dialog-actions>
